import {
  MultipleLinearProgressItem,
  MultipleLinearProgressSize,
  MultipleLinearProgressBorderRadiusType,
} from './types';

export const getTotalItems = (items: MultipleLinearProgressItem[]): number =>
  items.reduce((sum, curr) => sum + curr.value, 0);

export const getHeightBySize = (size: MultipleLinearProgressSize): number => {
  let height = 20;

  if (size === 'xSmall') height = 10;
  if (size === 'small') height = 12;
  if (size === 'large') height = 28;

  return height;
};

export const getBorderRadiusByType = (
  type:
    | MultipleLinearProgressBorderRadiusType
    | MultipleLinearProgressBorderRadiusType[],
  radius: number,
): string => {
  const values = { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 };

  const types = Array.isArray(type) ? type : [type];

  if (types.includes('left')) {
    values.topLeft = radius;
    values.bottomLeft = radius;
  }

  if (types.includes('right')) {
    values.topRight = radius;
    values.bottomRight = radius;
  }

  return `${values.topLeft}px ${values.topRight}px ${values.bottomRight}px ${values.bottomLeft}px`;
};
